/* i18n : chaînes servies par window.TL_I18N (layout/theme.liquid, depuis locales/*.json).
   Le littéral français reste en repli si le blob manque (script chargé hors thème). */
function tlT(k, fallback) { return (window.TL_I18N && window.TL_I18N[k]) || fallback; }

/* Tiloli card: quantity steppers (event-delegated, covers every card on the page).
   Guarded so loading the script more than once (e.g. once per product-card block) is safe. */
if (!window.__tlCardInit) {
  window.__tlCardInit = true;
  window.__tlDbg = window.__tlDbg || (typeof location !== 'undefined' && location.search.indexOf('tldebug') !== -1);
/* Paliers de quantité : min / pas / max posés sur [data-tlc-qty] par `quantity-rules.liquid`
   (règles Nexo répliquées via les métachamps custom.quantity_*). Sans attribut → 1/1/aucun. */
function tlQtyRules(wrap) {
  const min = parseInt(wrap && wrap.dataset.qtyMin, 10);
  const step = parseInt(wrap && wrap.dataset.qtyStep, 10);
  const max = parseInt(wrap && wrap.dataset.qtyMax, 10);
  return {
    min: min > 0 ? min : 1,
    step: step > 0 ? step : 1,
    max: max > 0 ? max : null,
  };
}

function tlSnapQty(qty, r) {
  if (!(qty > r.min)) return r.min;
  let snapped = r.min + Math.round((qty - r.min) / r.step) * r.step;
  if (r.max !== null && snapped > r.max) snapped = r.min + Math.floor((r.max - r.min) / r.step) * r.step;
  return snapped;
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-qty-dec], [data-qty-inc]');
  if (!btn) return;
  const wrap = btn.closest('[data-tlc-qty]');
  const input = wrap && wrap.querySelector('[data-qty-input]');
  if (!input) return;
  const r = tlQtyRules(wrap);
  const cur = parseInt(input.value, 10) || r.min;
  const next = btn.hasAttribute('data-qty-inc') ? cur + r.step : cur - r.step;
  input.value = tlSnapQty(next, r);
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

document.addEventListener('input', (e) => {
  const input = e.target.closest('[data-tlc-qty] [data-qty-input]');
  if (!input) return;
  const n = parseInt(input.value.replace(/[^0-9]/g, ''), 10);
  input.value = isNaN(n) || n < 1 ? '' : n;
});

/* Mention « Vendu par N · X pack(s) » : le compte suit la quantité saisie. Portée au
   conteneur courant — .tlbb (buy box, rappel sticky inclus) ou .tlc (carte catalogue) —
   pour ne pas toucher les autres cartes de la grille. */
function tlPackLabel(n) {
  const s = n === 1 ? tlT('packCountOne', '1 pack') : tlT('packCount', '[COUNT] packs');
  return s.replace('[COUNT]', n);
}
function tlSyncPackCount(input, qty, step) {
  const host = input.closest('.tlbb, .tlc');
  if (!host || !(step > 1)) return;
  const n = Math.max(1, Math.round(qty / step));
  host.querySelectorAll('[data-tl-packcount]').forEach((el) => { el.textContent = tlPackLabel(n); });
}

// On ne recale sur le palier qu'à la validation, pour ne pas corriger en pleine saisie.
document.addEventListener('change', (e) => {
  const input = e.target.closest('[data-tlc-qty] [data-qty-input]');
  if (!input) return;
  const wrap = input.closest('[data-tlc-qty]');
  const rules = tlQtyRules(wrap);
  input.value = tlSnapQty(parseInt(input.value, 10) || 0, rules);
  tlSyncPackCount(input, parseInt(input.value, 10) || rules.min, rules.step);
});

/* --- AJAX add-to-cart: stay on the page + bottom toast (forms tagged [data-tl-add]) --- */
function tlMoney(cents) {
  return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
}
function tlToast(msg, ok) {
  let t = document.getElementById('tl-toast');
  if (!t) {
    t = document.createElement('div');
    t.id = 'tl-toast';
    t.className = 'tl-toast';
    t.setAttribute('role', 'status');
    t.innerHTML = '<span class="tl-toast__ico"></span><span class="tl-toast__msg"></span>';
    document.body.appendChild(t);
  }
  t.querySelector('.tl-toast__msg').textContent = msg;
  t.classList.toggle('tl-toast--err', !ok);
  t.classList.add('is-on');
  clearTimeout(t._timer);
  t._timer = setTimeout(() => t.classList.remove('is-on'), 3500);
}
async function tlRefreshCart() {
  try {
    const c = await (await fetch('/cart.js')).json();
    document.querySelectorAll('[data-cart-count]').forEach((e) => { e.textContent = c.item_count; });
    document.querySelectorAll('[data-cart-total]').forEach((e) => { e.textContent = tlMoney(c.total_price); });
  } catch (_) { /* noop */ }
}
document.addEventListener('submit', async (e) => {
  const host = e.target.closest('[data-tl-add]');
  if (!host) return;
  const form = e.target.closest('form');
  if (!form) return;
  e.preventDefault();
  const btn = form.querySelector('[type="submit"]');
  if (btn) btn.disabled = true;
  try {
    const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    const data = await res.json();
    if (!res.ok) throw data;
    const qty = data.quantity || parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10);
    const title = host.getAttribute('data-title') || data.product_title || tlT('productFallback', 'Produit');
    tlToast(tlT('addedToast', 'Ajouté au panier · [QTY] × [TITLE]').replace('[QTY]', qty).replace('[TITLE]', title), true);
    tlRefreshCart();
  } catch (err) {
    tlToast((err && err.description) || tlT('addError', "Impossible d'ajouter au panier"), false);
  } finally {
    if (btn) btn.disabled = false;
  }
});

/* --- Prix B2B : cache + anti-flash (connecté) ---
   Le net négocié d'une variante ne change pas d'un filtre à l'autre (mêmes produits). On le met en
   cache (sessionStorage, par client+variante, TTL 30 min) et on le réinjecte INSTANTANÉMENT à chaque
   re-render → plus de skeleton ni d'appel pour les variantes déjà vues. */
var TL_NET_TTL = 30 * 60 * 1000;
function tlNetKey(el) {
  var v = el.getAttribute('data-variant-id');
  if (!v) return null;
  return 'tlnet:' + (el.getAttribute('data-cust') || 'pro') + ':' + v;
}
function tlNetGet(key) {
  try { var r = JSON.parse(sessionStorage.getItem(key)); if (r && (Date.now() - r.t) < TL_NET_TTL) return r.v; } catch (_) {}
  return null;
}
function tlNetSet(key, v) { try { sessionStorage.setItem(key, JSON.stringify({ v: v, t: Date.now() })); } catch (_) {} }
function tlWriteNet(el, text) {
  var n = el.querySelector('.tl-price__net');
  if (n) { n.innerHTML = '<span class="price-item price-item--regular">' + text + '</span>'; }
}
/* Volet « Pack xN » : prix du pack = net unitaire x palier (custom.quantity_increment, posé
   sur data-tl-pack par tiloli-price.liquid). Liquid ne peut pas le rendre — le net négocié
   n'arrive qu'ici. Le PVC du pack, lui, est déjà rendu côté serveur. */
function tlWritePack(el, netHt) {
  var step = parseInt(el.getAttribute('data-tl-pack'), 10);
  var t = el.querySelector('.tl-price__packnet');
  if (!t || !(step > 1) || !(netHt > 0)) return;
  t.innerHTML = '<span class="price-item price-item--regular">' + tlFmtHt(netHt * step) + '</span>';
}
/* Relecture d'un net déjà formaté (cache session) : tlFmtHt produit du fr-FR, donc virgule
   décimale et espaces de milliers. On ne garde que les chiffres et la virgule. */
function tlParseHt(text) {
  var n = parseFloat(String(text).replace(/[^\d,]/g, '').replace(',', '.'));
  return isNaN(n) ? 0 : n;
}
/* Reseller pre-promo "was" (barré): the sync writes it per logged-in customer to
   data-tl-reseller-was (from the b2b.reseller_base_ht metafield). Idempotent
   (guards on the already-present marker). */
function tlApplyResellerWas(el) {
  if (el.classList.contains('tl-price--card')) return; // cartes : pas de re-injection (anti-scintillement)
  var was = el.getAttribute('data-tl-reseller-was');
  if (!was) return;
  var row = el.querySelector('.tl-price__row');
  if (!row) return;
  if (row.querySelector('.tl-price__old--reseller')) return; // already applied (server or earlier)
  // Layout: net · €HT · −X% badge · ~~was~~ (so we never show two struck prices).
  var wasSpan = row.querySelector('.tl-price__old');
  if (wasSpan) {
    wasSpan.textContent = was;
    wasSpan.className = (wasSpan.className ? wasSpan.className + ' ' : '') + 'tl-price__old tl-price__old--reseller';
  } else {
    wasSpan = document.createElement('span');
    wasSpan.className = 'tl-price__old tl-price__old--reseller';
    wasSpan.textContent = was;
  }
  // −X% badge (from data-tl-pct), inserted before the struck "was".
  // PAS sur les cartes (collections/reco/recherche) : elles ont leur propre .tlc__badge.
  var pct = el.getAttribute('data-tl-pct');
  var badge = null;
  if (pct && !el.classList.contains('tl-price--card') && !row.querySelector('.tl-price__badge')) {
    badge = document.createElement('span');
    badge.className = 'tl-chip tl-price__badge';
    badge.textContent = '−' + pct + '%';
  }
  row.appendChild(wasSpan);            // move the "was" to the end
  if (badge) row.insertBefore(badge, wasSpan); // badge just before it
}
/* --- Moteur prix "own" (API App Proxy) ---
   On récupère le net négocié du client connecté via GET /apps/b2b/prices?variant_ids=…
   (App Proxy signe + injecte le client) et on l'écrit dans .tl-price__net. Le barré reseller /
   PVC / éco-part sont rendus côté serveur → pas d'observer, pas de flash. */
// Number only (no € symbol): .tl-price__net is followed by a separate "€ HT"
// unit span in the theme, so we must NOT add our own € (else "8,00 € € HT").
function tlFmtHt(n) { return (Number(n) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
/* Coalesced fetch: many triggers (DOMContentLoaded, tl:cards-injected, reactive
   hydrate) enqueue variants; a 50ms debounce batches them into ONE request.
   This kills the N+1 single-variant fetches that could queue past the skeleton's
   3s reveal → base price flashing before the net. We reveal (.tl-price--ready)
   ONLY after writing the real net, so the wrong base never shows. */
var tlOwnQueue = {};   // variantId -> [elements awaiting a price]
var tlOwnTimer = null;
function tlOwnEnqueue(el) {
  if (!el || !el.classList || el.classList.contains('tl-price--ready') || !el.getAttribute('data-cust')) return;
  var vid = el.getAttribute('data-variant-id');
  if (!vid) { el.classList.add('tl-price--ready'); return; }
  var key = tlNetKey(el), cached = key && tlNetGet(key);
  if (cached) { tlWriteNet(el, cached); tlWritePack(el, tlParseHt(cached)); tlApplyResellerWas(el); el.classList.add('tl-price--ready'); return; } // cache → instant, no flash
  (tlOwnQueue[vid] = tlOwnQueue[vid] || []).push(el);
  if (!tlOwnTimer) tlOwnTimer = setTimeout(tlOwnFlush, 50);
}
/* #352: the price API slices variant_ids at 250 server-side (b2b-price-api). A flush bigger
   than that (promo hub loads hundreds of cards at once) used to silently drop the tail →
   those cards revealed the PUBLIC price. Chunk client-side; chunks fetch in parallel and
   resolve independently (each chunk reveals its own elements, success or failure). */
var TL_OWN_CHUNK = 250;
function tlOwnFetchChunk(endpoint, ids, batch) {
  fetch(endpoint + '?variant_ids=' + encodeURIComponent(ids.join(',')), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
    .then(function (resp) { return resp.ok ? resp.json() : { prices: [] }; })
    .then(function (data) {
      var priced = {};
      (data.prices || []).forEach(function (p) { priced[p.variantId] = p; });
      ids.forEach(function (vid) {
        var p = priced[vid];
        (batch[vid] || []).forEach(function (el) {
          if (p) { var net = tlFmtHt(p.netHt); tlWriteNet(el, net); tlWritePack(el, Number(p.netHt)); var k = tlNetKey(el); if (k) tlNetSet(k, net); tlApplyResellerWas(el); }
          el.classList.add('tl-price--ready'); // reveal AFTER writing (or base when no price returned)
        });
      });
      if (window.__tlDbg) console.log('[TL own] priced', (data.prices || []).length, '/', ids.length);
    })
    .catch(function () { ids.forEach(function (vid) { (batch[vid] || []).forEach(function (el) { el.classList.add('tl-price--ready'); }); }); });
}
function tlOwnFlush() {
  tlOwnTimer = null;
  var ids = Object.keys(tlOwnQueue);
  if (!ids.length) return;
  var batch = tlOwnQueue; tlOwnQueue = {};
  var endpoint = window.TL_PRICE_ENDPOINT || '/apps/b2b/prices';
  for (var i = 0; i < ids.length; i += TL_OWN_CHUNK) {
    tlOwnFetchChunk(endpoint, ids.slice(i, i + TL_OWN_CHUNK), batch);
  }
}
function tlOwnArmPrices(root) {
  (root || document).querySelectorAll('.tl-price[data-cust]:not(.tl-price--ready)').forEach(tlOwnEnqueue);
}
function tlArmPrices(root) {
  tlOwnArmPrices(root); // moteur own : fetch + render
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => tlArmPrices());
} else {
  tlArmPrices();
}
// prix (ré)injectés en AJAX (reco, grille filtrée) → ré-armer
document.addEventListener('tl:cards-injected', (e) => tlArmPrices((e.detail && e.detail.container) || document));

// Hydratation RÉACTIVE depuis le cache : dès qu'un prix caché est inséré (carte
// nouvellement insérée OU nœud réutilisé/patché par le morph qui ré-ajoute la base),
// on réinjecte le net du cache — avant le paint → aucun flash base→net.
function tlHydrateCached(el) {
  if (!el.classList || !el.getAttribute('data-cust') || el.classList.contains('tl-price--ready')) return;
  var key = tlNetKey(el);
  var cached = key && tlNetGet(key);
  if (cached) {
    tlWriteNet(el, cached);
    tlWritePack(el, tlParseHt(cached));
    tlApplyResellerWas(el);
    el.classList.add('tl-price--ready'); // reveal EN DERNIER → ne re-matche plus, prix déjà décoré
  } else {
    tlOwnEnqueue(el); // own : enqueue into the coalesced batch (no per-element fetch)
  }
}
if ('MutationObserver' in window) {
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      if (m.type === 'attributes') {
        if (m.target.nodeType === 1 && m.target.matches && m.target.matches('.tl-price[data-cust]:not(.tl-price--ready)')) tlHydrateCached(m.target);
        continue;
      }
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches('.tl-price[data-cust]')) tlHydrateCached(n);
        else if (n.querySelectorAll) { var ps = n.querySelectorAll('.tl-price[data-cust]'); for (var k = 0; k < ps.length; k++) tlHydrateCached(ps[k]); }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
}
}
